
<div class="row align-items-start mt-8" style="display: flex;margin-top:10px;">
 
 <app-member-card *ngFor='let member of memberdata;' [memberdata]="member" [index]="index" class="ml-2"></app-member-card>
</div>